/** @jsx h */
/** @jsxFrag Fragment */
import { h } from "preact";
import { DatUIBaseProps } from "./dat.tsx";
import { cx } from "@utils/utils";

export interface DatBooleanProps extends DatUIBaseProps {
  value: boolean;
  onChange: (value: boolean) => void;
}
export function DatBoolean(props: DatBooleanProps) {
  const labelWidth = "40%";
  const labelText = props.label || "DefaultLabel";

  return (
    <li class={cx("cr", "boolean", props.class)} style={props.style}>
      <label>
        <span class="label-text" style={{ width: labelWidth }}>
          {labelText}
        </span>
        <span class="checkbox-container" style={{ width: `calc(100% - ${labelWidth})` }}>
          <input
            type="checkbox"
            checked={props.value}
            onChange={() => props.onChange(!props.value)}
          />
        </span>
      </label>
    </li>
  );
}
